import { render, staticRenderFns } from "./examVerify.vue?vue&type=template&id=065a724e&scoped=true&"
import script from "./examVerify.vue?vue&type=script&lang=js&"
export * from "./examVerify.vue?vue&type=script&lang=js&"
import style0 from "./examVerify.vue?vue&type=style&index=0&id=065a724e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a724e",
  null
  
)

export default component.exports